import React from 'react';
// Components
import GeneralMainSection from '../general/GeneralMainSection';
// Images
import GroundworksImage from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-frame-small.jpg';
import GroundworksImage2 from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-landscaping-groundworking-digger.jpg';
import GroundworksImage3 from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-landscaping-groundworking-digger-home.jpg';
import GeneralFooter from '../general/GeneralFooter';

function GroundworksPageMainContainer() {
  const groundworksPageData = {
    headerSentence: 'Professional Groundworks & Site Preparation',
    description:
      'Ascari Building Contractors provides expert groundworks services, ensuring a solid foundation for all types of construction projects. From site preparation to drainage solutions, we handle every aspect with precision and care.',
    services: [
      {
        title: 'Foundations & Footings',
        description:
          'Excavation, concrete footings, and reinforced foundations to support new builds and extensions.',
      },
      {
        title: 'Drainage & Sewage Systems',
        description:
          'Installation of drainage systems, soakaways, and sewage connections to prevent water buildup and flooding.',
      },
      {
        title: 'Driveways & Paving',
        description:
          'High-quality block paving, concrete, tarmac, and gravel driveways for durable and stylish entrances.',
      },
      {
        title: 'Site Clearance & Excavation',
        description:
          'Land clearing, earthworks, and site leveling to prepare for new construction projects.',
      },
      {
        title: 'Retaining Walls & Landscaping',
        description:
          'Structural retaining walls, garden landscaping, and groundwork preparation for outdoor spaces.',
      },
      {
        title: 'Concrete Slabs & Bases',
        description:
          'Precision-laid concrete bases for sheds, garages, and outdoor structures.',
      },
    ],
    commitment:
      'Our experienced team ensures that every groundwork project is completed to the highest standards, providing a strong and stable base for any development. We work efficiently to minimize disruption while delivering quality results.',
    mainImage: GroundworksImage,
    secondImage: GroundworksImage,
    mainImageAlt: 'Groundworks team preparing a construction site',
    imageTwo: GroundworksImage2,
    imageThree: GroundworksImage3,
  };

  return (
    <main
      role='main'
      className='grid pt-8 sm:pt-10 md:pt-12 gap-12 lg:gap-24 w-full h-full'
    >
      <GeneralMainSection {...groundworksPageData} />

      <GeneralFooter title={`Groundworks`} />
    </main>
  );
}

export default GroundworksPageMainContainer;
